import { render, staticRenderFns } from "./PublicBoard.vue?vue&type=template&id=46efd4c0&"
import script from "./PublicBoard.vue?vue&type=script&lang=js&"
export * from "./PublicBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports